export { default as AuditViewPageComponent } from './audit-view-page.component';
export * from './audit-view-page.component';
